import React, { useEffect, useState } from 'react';
import '@/assets/sass/style.scss';
import Swagger from '@/components/Swagger';

const Main = () => {
  const [info, setInfo] = useState({ type: '', defaultUrl: '', configUrl: '', specUrl: '' });

  const fetchEnvironment = async () => {
    const result = await fetch('./environment.json');
    const environment = await result.json();
    setInfo(environment);
  };

  useEffect(() => {
    fetchEnvironment();
  }, []);

  return (
    <Swagger type={info.type} defaultUrl={info.defaultUrl} domainListUrl={info.configUrl} docsUrl={info.specUrl} />
  );
};

export default Main;
